import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX, FiSend } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      // Update URL hash
      window.history.pushState(null, '', `#${sectionId}`);
      // Close mobile menu if open
      setIsMenuOpen(false);
    }
  };

  return (
    <motion.header 
      className="fixed top-0 w-full bg-white/90 backdrop-blur-md border-b border-gray-200 z-50 transition-all duration-300"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <a href="#" className="flex items-center space-x-2 group">
            <div className="relative transform group-hover:-translate-y-1 transition-transform duration-300">
              <SafeIcon icon={FiSend} className="text-3xl text-brand-teal transform rotate-45" />
              <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-brand-yellow rounded-full animate-pulse"></div>
            </div>
            <span className="text-2xl font-bold text-brand-navy tracking-tight">Postifyr</span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <button 
              onClick={() => scrollToSection('features')} 
              className="text-gray-600 font-medium hover:text-brand-teal transition-colors"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('pricing')} 
              className="text-gray-600 font-medium hover:text-brand-teal transition-colors"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')} 
              className="text-gray-600 font-medium hover:text-brand-teal transition-colors"
            >
              Testimonials
            </button>
            <a 
              href="https://dashboard.postifyr.com/" 
              className="text-gray-600 font-medium hover:text-brand-teal transition-colors"
            >
              Login
            </a>
            <a 
              href="https://dashboard.postifyr.com/rsa176125959b2e527cd97c7b79622c6fdb?ref=nav" 
              className="bg-brand-teal text-white px-6 py-3 rounded-xl font-semibold hover:bg-brand-navy hover:scale-105 transition-all shadow-lg shadow-brand-teal/20"
            >
              Start Free Trial
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-2xl text-brand-navy" />
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <motion.nav 
            className="md:hidden py-6 border-t border-gray-100 bg-white absolute left-0 right-0 shadow-xl"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <div className="flex flex-col space-y-4 px-4">
              <button 
                onClick={() => scrollToSection('features')} 
                className="text-gray-700 font-medium hover:text-brand-teal p-2 text-left"
              >
                Features
              </button>
              <button 
                onClick={() => scrollToSection('pricing')} 
                className="text-gray-700 font-medium hover:text-brand-teal p-2 text-left"
              >
                Pricing
              </button>
              <button 
                onClick={() => scrollToSection('testimonials')} 
                className="text-gray-700 font-medium hover:text-brand-teal p-2 text-left"
              >
                Testimonials
              </button>
              <a 
                href="https://dashboard.postifyr.com/" 
                className="text-gray-700 font-medium hover:text-brand-teal p-2 text-left"
                onClick={() => setIsMenuOpen(false)}
              >
                Login
              </a>
              <a 
                href="https://dashboard.postifyr.com/rsa176125959b2e527cd97c7b79622c6fdb?ref=nav-mobile" 
                className="bg-brand-teal text-white px-6 py-3 rounded-xl font-semibold text-center hover:bg-brand-navy transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Start Free Trial
              </a>
            </div>
          </motion.nav>
        )}
      </div>
    </motion.header>
  );
};

export default Header;